export default __webpack_public_path__ + "static/media/1.a8e882c2.jpeg";